export const initiateMemberOffersListeners = function () {
  const offersContainer = document.getElementById('offers-container');
  if (offersContainer) {
    // Show modal
    const buttonList = offersContainer.querySelectorAll('button');
    buttonList.forEach((button) => {
      // eslint-disable-next-line no-param-reassign
      button.onclick = () => {
        button.parentNode.querySelector('.offer-modal').classList.remove('offer-modal-hidden');
        document.body.style.overflow = 'hidden';
        let offerName = button.previousElementSibling.textContent;
        if (window.cts) {
            cts.send.event('action', 'click', 'offer-tracking|offer|'+offerName);
        }
      };
    });
    // Hide modal
    const modals = offersContainer.querySelectorAll('.offer-modal');
    modals.forEach((modal) => {
      // eslint-disable-next-line no-param-reassign
      modal.onclick = (event) => {
        if (event.target === modal || event.target === modal.querySelector('.offer-modal-close')) {
          modal.classList.add('offer-modal-hidden');
          document.body.style.overflow = 'auto';
        }
      };
    });
    // Copy code
    const copyIcons = offersContainer.querySelectorAll('.copy-icon');
    copyIcons.forEach((icon) => {
      icon.addEventListener('click', () => {
        // Create temporary input to have something to copy from
        const tempInput = document.createElement('input');
        tempInput.style = 'position: absolute; left: -1000px; top: -1000px';
        tempInput.value = icon.dataset.valueToCopy;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand('copy');
        document.body.removeChild(tempInput);
        // Show and then hide copy confirmation
        const copyConfirmationEl = icon.parentNode.querySelector('.offer-copied-confirmation');
        copyConfirmationEl.classList.add('show-offer-confirmation');
        setTimeout(() => {
          copyConfirmationEl.classList.remove('show-offer-confirmation');
        }, 2000);
      });
    });
  }
};
